import {LABELS} from '@github-ui/item-picker-base/constants/labels'
import {GitBranchIcon, TriangleDownIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'

export type DefaultBranchPickerAnchorProps = {
  branchName?: string
  readonly?: boolean
} & React.HTMLAttributes<HTMLElement> & {ref?: React.Ref<HTMLButtonElement>}

export const DefaultBranchPickerAnchor = ({
  ref: branchPickerRef,
  branchName,
  readonly,
  ...anchorProps
}: DefaultBranchPickerAnchorProps) => (
  <Button
    leadingVisual={GitBranchIcon}
    trailingVisual={TriangleDownIcon}
    aria-label={!anchorProps?.['aria-labelledby'] ? LABELS.selectBranch : undefined}
    disabled={readonly}
    {...anchorProps}
    ref={branchPickerRef}
  >
    {branchName ? <span>{branchName}</span> : LABELS.selectBranch}
  </Button>
)

DefaultBranchPickerAnchor.displayName = 'DefaultBranchPickerAnchor'
